<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-container-single element-non-bodymatter element-type-none element-with-heading" id="quotes">
<div class="heading heading-with-title heading-without-image" id="quotes-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">Quotes</h1>
</div>
<h3 class="subtitle">Unnatural Praise for Dan Shamble, Zombie P.I.</h3>
</div>
</div>
</div>
<div class="text" id="quotes-text">
<p class="first first-in-chapter first-full-width"><i>“The Dan Shamble books are great fun.”</i></p>
<div class="alignment-block alignment-block-align-right">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-right">—Simon R. Green</p>
</div>
</div>
<p class="subsq"><i>“Sharp and funny; this zombie detective rocks!”</i></p>
<div class="alignment-block alignment-block-align-right">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-right">—Patricia Briggs</p>
</div>
</div>
<p class="subsq"><i>“A dead detective, a wimpy vampire, and other interesting characters from the supernatural side of the street make </i>Death Warmed Over<i> an unpredictable walk on the weird side. Prepare to be entertained.”</i></p>
<div class="alignment-block alignment-block-align-right">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-right">—Charlaine Harris</p>
</div>
</div>
<p class="subsq"><i>“A darkly funny, wonderfully original detective tale.”</i></p>
<div class="alignment-block alignment-block-align-right">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-right">—Kelley Armstrong</p>
</div>
</div>
<p class="subsq"><i>“Master storyteller Kevin J. Anderson’s </i>Death Warmed Over<i> is wickedly funny, deviously twisted and enormously satisfying. This is a big juicy bite of zombie goodness. Two decaying thumbs up!”</i></p>
<div class="alignment-block alignment-block-align-right">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-right">—Jonathan Maberry</p>
</div>
</div>
<p class="subsq"><i>“Kevin J. Anderson shambles into Urban Fantasy with his usual relentless imagination, and a unique hard-boiled detective who’s refreshing, if not exactly fresh. </i>Death Warmed Over<i> is the literary equivalent of Pop Rocks, firing up an original world with supernatural zing, bold flavor, and endlessly clever surprise.”</i></p>
<div class="alignment-block alignment-block-align-right">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-right">—Vicki Pettersson</p>
</div>
</div>
<p class="subsq"><i>“</i>Death Warmed Over<i> is just plain good fun. I enjoyed every minute it took me to read it.”</i></p>
<div class="alignment-block alignment-block-align-right">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-right">—Glen Cook</p>
</div>
</div>
<p class="subsq"><i>“Down these mean streets a man must lurch.…With his Big Sleep interrupted, Chambeaux the zombie private eye goes back to sleuthing, in </i>Death Warmed Over<i>, Kevin J. Anderson’s wry and inventive take on the Noir paradigm. The bad guys are werewolves, the clients are already deceased, and the readers are in for a funny, action-packed adventure, following that dead man walking …”</i></p>
<div class="alignment-block alignment-block-align-right">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-right">—Sharyn McCrumb</p>
</div>
</div>
<p class="subsq"><i>“A zombie sleuth prowls the mean streets as he works a half-dozen seriously weird cases … Like Alexander McCall Smith’s Mma Precious Ramotswe, the sleuths really do settle most of their cases, and they provide a lot of laughs along the way.”</i></p>
<div class="alignment-block alignment-block-align-right">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-right">—<i>Kirkus Reviews </i>on<i> Death Warmed Over</i></p>
</div>
</div>
<p class="subsq"><i>“Anderson’s world-building skills shine through in his latest series, Dan Shamble, P.I. Readers looking for a mix of humor, romance, and good old-fashioned detective work will be delighted by this offering.”</i></p>
<div class="alignment-block alignment-block-align-right">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-right">—<i>RT Book Reviews</i> (4 stars)</p>
</div>
</div>
<p class="subsq"><i>“Less-than-scary vampires, hit-man werewolves, witches who sue the publishing company who didn’t do a ‘spell check,’ and various levels of decaying zombies, monsters, ghosts, trolls, goblins and other creatures (some even human) combine into one twisted, tasty treat!”</i></p>
<div class="alignment-block alignment-block-align-right">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-right">—<i>Stratton Magazine</i></p>
</div>
</div>
<p class="subsq"><i>“Fast-paced and full of fun characters, adventure, suspense, mystery, and humor<b>—</b></i>Death Warmed Over<i> is the first in a promising new series. Urban fantasy fans should check out this unpredictable and complex story.”</i></p>
<div class="alignment-block alignment-block-align-right">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-right">—Sci Fi Chick</p>
</div>
</div>
<p class="subsq"><i>“Funny and entertaining.… If you are looking for a light, entertaining read, this book is undead from front to back, and a lot of fun!”</i></p>
<div class="alignment-block alignment-block-align-right">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-right">—<i>You’d Only Slow Me Down</i></p>
</div>
</div>
<p class="subsq"><i>“Part </i>Chinatown<i>, part horror comedy, </i>Death Warmed Over <i>is entirely fun.”</i></p>
<div class="alignment-block alignment-block-align-right">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-right">—<i>Roqoo Depot</i></p>
</div>
</div>
<p class="subsq"><i>“Anderson’s hilarious, lighthearted tale blends paranormal fiction with hardboiled detective stories to give a unique look at some of the issues that might occur should supernatural creatures populate our world. Anderson doesn’t bring readers into his fictional world, he brings fictional characters into our world. The noir-y feel of this hybrid paranormal-mystery story definitely gives it the realism that makes Anderson’s world-building entirely believable.”</i></p>
<div class="alignment-block alignment-block-align-right">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-right">—“Elisa and Janine Dish” in <i>RT Book Reviews</i></p>
</div>
</div>
<p class="subsq"><i>“A good detective doesn’t let a little thing like getting murdered slow him down, and I got a kick out of Shamble trying to solve a series of oddball cases, including his own. He’s the kind of zombie you want to root for, and his cases are good, light hearted fun.”</i></p>
<div class="alignment-block alignment-block-align-right">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-right">—Larry Correia, <i>New York Times</i> bestselling author of the Monster Hunter International series</p>
</div>
</div>
<p class="subsq"><i>“Kevin J. Anderson’s </i>Death Warmed Over<i> and his Dan Shamble, Zombie P.I. novels are truly pure reading enjoyment—funny, intriguing—and written in a voice that charms the reader from the first page and onward. Smart, savvy—fresh, incredibly clever! I love these books.”</i></p>
<div class="alignment-block alignment-block-align-right">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-right">—Heather Graham, <i>New York Times</i> bestselling author of the Krewe of Hunters series</p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// quotes.vue?b5f0bc2c